import { Card, Box } from "@mui/material";

const CardBanner: React.FC<{imgUrl: string, bgColor?: string} & React.PropsWithChildren> = ({imgUrl, children, bgColor='#fbbc04'}) => {
    return <Box sx={{display: 'inline-flex', width: '100%', justifyContent: 'right'}}>
        <Card sx={{
            backgroundColor: bgColor,
            minWidth: '100%',
            borderRadius: '1.5rem',
            height: '12rem',
            zIndex: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
            boxShadow: 'none',
            backgroundImage: `linear-gradient(90deg, ${bgColor} 60%, transparent 70%), url(/img/${imgUrl})`,
            backgroundSize: 'cover'
        }}>
            {children}
        </Card>
    </Box>
};

export default CardBanner;